module.exports = __webpack_public_path__ + "static/media/spatula.aab4b862.png";